import React, { useEffect, createElement } from 'react';
import { UrgencyBar } from '../components/landing/UrgencyBar';
import { HeroSection } from '../components/landing/HeroSection';
import { PainSection } from '../components/landing/PainSection';
import { ComparisonTable } from '../components/landing/ComparisonTable';
import { MechanismSection } from '../components/landing/MechanismSection';
import { SecretsSection } from '../components/landing/SecretsSection';
import { WarningSection } from '../components/landing/WarningSection';
import { ModulesSection } from '../components/landing/ModulesSection';
import { TestimonialsSection } from '../components/landing/TestimonialsSection';
import { PricingSection } from '../components/landing/PricingSection';
import { GuaranteeSection } from '../components/landing/GuaranteeSection';
import { FAQSection } from '../components/landing/FAQSection';
import { FinalCTASection } from '../components/landing/FinalCTASection';
import { DisclaimerSection } from '../components/landing/DisclaimerSection';
import { FooterSection } from '../components/landing/FooterSection';
export function LandingPage() {
  useEffect(() => {
    // Set page title
    document.title = 'Manual Digital de Sanación Natural — 100+ Recetas Ancestrales';
    // Meta Pixel — corrected initialization
    if (typeof window !== 'undefined') {
      const f = window as any;
      if (!f.fbq) {
        f.fbq = function () {
          f.fbq.callMethod ? f.fbq.callMethod.apply(f, arguments) : f.fbq.queue.push(arguments);
        };
        if (!f._fbq) f._fbq = f.fbq;
        f.fbq.push = f.fbq;
        f.fbq.loaded = !0;
        f.fbq.version = '2.0';
        f.fbq.queue = [];
        const t = document.createElement('script');
        t.async = !0;
        t.src = 'https://connect.facebook.net/en_US/fbevents.js';
        document.head.appendChild(t);
      }
      f.fbq('init', '26627694000165817');
      f.fbq('track', 'PageView');
      f.fbq('track', 'ViewContent', {
        content_name: 'Landing Page Manual Ancestral',
        currency: 'USD',
        value: 17
      });
    }
  }, []);
  return <div className="min-h-screen font-body text-marron bg-white" data-id="element-317">
      {/* Meta Pixel noscript fallback */}
      <noscript data-id="element-318">
        <img height="1" width="1" style={{
        display: 'none'
      }} src="https://www.facebook.com/tr?id=26627694000165817&ev=PageView&noscript=1" alt="" data-id="element-319" />
      </noscript>
      <UrgencyBar data-id="element-320" />
      <HeroSection data-id="element-321" />
      <PainSection data-id="element-322" />
      <ComparisonTable data-id="element-323" />
      <MechanismSection data-id="element-324" />
      <SecretsSection data-id="element-325" />
      <WarningSection data-id="element-326" />
      <ModulesSection data-id="element-327" />
      <TestimonialsSection data-id="element-328" />
      <PricingSection data-id="element-329" />
      <GuaranteeSection data-id="element-330" />
      <FAQSection data-id="element-331" />
      <FinalCTASection data-id="element-332" />
      <DisclaimerSection data-id="element-333" />
      <FooterSection data-id="element-334" />
    </div>;
}